import React from 'react';
import { BlockPicker } from 'react-color';

import { Button, ColorPicker } from '@shopify/polaris';

const SuggestedColors = ['#000', '#808080', '#ff0000', '#0000ff', '#008000'];

const ColorPickerCard = ({
  toggleIsStylesEnabled,
  isStylesEnabled,
  handleChange,
  firstColumnColor,
  secondColumnColor,
  thirdColumnColor,
  fourthColumnColor,
  fifthColumnColor,
  sixthColumnColor,
  firstColumnName,
  secondColumnName,
  thirdColumnName,
  fourthColumnName,
  fifthColumnName,
  sixthColumnName,
}) => {
  const firstColumnTitle = firstColumnName
    ?.replace(/([A-Z])/g, ' $1')
    .replace(/^./, function (str) {
      return str.toUpperCase();
    })
    .split(' ')
    .slice(1)
    .join(' ');

  const secondColumnTitle = secondColumnName
    ?.replace(/([A-Z])/g, ' $1')
    .replace(/^./, function (str) {
      return str.toUpperCase();
    })
    .split(' ')
    .slice(1)
    .join(' ');

  const thirdColumnTitle = thirdColumnName
    ?.replace(/([A-Z])/g, ' $1')
    .replace(/^./, function (str) {
      return str.toUpperCase();
    })
    .split(' ')
    .slice(1)
    .join(' ');

  const fourthColumnTitle = fourthColumnName
    ?.replace(/([A-Z])/g, ' $1')
    .replace(/^./, function (str) {
      return str.toUpperCase();
    })
    .split(' ')
    .slice(1)
    .join(' ');

  const fifthColumnTitle = fifthColumnName
    ?.replace(/([A-Z])/g, ' $1')
    .replace(/^./, function (str) {
      return str.toUpperCase();
    })
    .split(' ')
    .slice(1)
    .join(' ');

  const sixthColumnTitle = sixthColumnName
    ?.replace(/([A-Z])/g, ' $1')
    .replace(/^./, function (str) {
      return str.toUpperCase();
    })
    .split(' ')
    .slice(1)
    .join(' ');
  return (
    <form onSubmit={() => {}}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <p>
          Custom section style colors are <b>{isStylesEnabled ? 'Enable' : 'Disable'}</b>
        </p>
        <Button primary={!isStylesEnabled} onClick={toggleIsStylesEnabled}>
          {isStylesEnabled ? 'Disable' : 'Enable'}
        </Button>
      </div>
      {isStylesEnabled && (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gridTemplateRows: '1fr',
            gridGap: '15px',
            marginTop: '10px',
            background: '#F4F6F8',
            padding: '20px',
            borderRadius: ' 3px',
          }}>
          <div>
            <b style={{ fontSize: '12px', marginBottom: '12px', display: 'block', textAlign: 'center' }}>{firstColumnTitle}:</b>
            <BlockPicker
              width='100%'
              onChangeComplete={handleChange(firstColumnName)}
              colors={SuggestedColors}
              color={firstColumnColor}
              color={{
                h: firstColumnColor?.hue,
                s: firstColumnColor?.saturation,
                l: firstColumnColor?.brightness,
                a: firstColumnColor?.alpha,
              }}
            />
          </div>
          {secondColumnName && (
            <div>
              <b style={{ fontSize: '12px', marginBottom: '12px', display: 'block', textAlign: 'center' }}>
                {secondColumnTitle}:
              </b>
              <BlockPicker
                width='100%'
                onChangeComplete={handleChange(secondColumnName)}
                colors={SuggestedColors}
                color={secondColumnColor}
                color={{
                  h: secondColumnColor?.hue,
                  s: secondColumnColor?.saturation,
                  l: secondColumnColor?.brightness,
                  a: secondColumnColor?.alpha,
                }}
              />
            </div>
          )}
          {thirdColumnName && (
            <div>
              <b style={{ fontSize: '12px', marginBottom: '12px', display: 'block', textAlign: 'center' }}>{thirdColumnTitle}:</b>
              <BlockPicker
                width='100%'
                onChangeComplete={handleChange(thirdColumnName)}
                colors={SuggestedColors}
                color={thirdColumnColor}
                color={{
                  h: thirdColumnColor?.hue,
                  s: thirdColumnColor?.saturation,
                  l: thirdColumnColor?.brightness,
                  a: thirdColumnColor?.alpha,
                }}
              />
            </div>
          )}
          {fourthColumnName && (
            <div>
              <b style={{ fontSize: '12px', marginBottom: '12px', display: 'block', textAlign: 'center' }}>
                {fourthColumnTitle}:
              </b>
              <BlockPicker
                width='100%'
                onChangeComplete={handleChange(fourthColumnName)}
                colors={SuggestedColors}
                color={fourthColumnColor}
                color={{
                  h: fourthColumnColor?.hue,
                  s: fourthColumnColor?.saturation,
                  l: fourthColumnColor?.brightness,
                  a: fourthColumnColor?.alpha,
                }}
              />
            </div>
          )}
          {fifthColumnName && (
            <div>
              <b style={{ fontSize: '12px', marginBottom: '12px', display: 'block', textAlign: 'center' }}>{fifthColumnTitle}:</b>
              <BlockPicker
                width='100%'
                onChangeComplete={handleChange(fifthColumnName)}
                colors={SuggestedColors}
                color={fifthColumnColor}
                color={{
                  h: fifthColumnColor?.hue,
                  s: fifthColumnColor?.saturation,
                  l: fifthColumnColor?.brightness,
                  a: fifthColumnColor?.alpha,
                }}
              />
            </div>
          )}
          {sixthColumnName && (
            <div>
              <b style={{ fontSize: '12px', marginBottom: '12px', display: 'block', textAlign: 'center' }}>{sixthColumnTitle}:</b>
              <BlockPicker
                width='100%'
                onChangeComplete={handleChange(sixthColumnName)}
                colors={SuggestedColors}
                color={sixthColumnColor}
                color={{
                  h: sixthColumnColor?.hue,
                  s: sixthColumnColor?.saturation,
                  l: sixthColumnColor?.brightness,
                  a: sixthColumnColor?.alpha,
                }}
              />
            </div>
          )}
        </div>
      )}
    </form>
  );
};

export default ColorPickerCard;
